import { render, staticRenderFns } from "./SetTypeToExercises.vue?vue&type=template&id=da983d98"
import script from "./SetTypeToExercises.vue?vue&type=script&lang=js"
export * from "./SetTypeToExercises.vue?vue&type=script&lang=js"
import style0 from "./SetTypeToExercises.vue?vue&type=style&index=0&id=da983d98&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da983d98')) {
      api.createRecord('da983d98', component.options)
    } else {
      api.reload('da983d98', component.options)
    }
    module.hot.accept("./SetTypeToExercises.vue?vue&type=template&id=da983d98", function () {
      api.rerender('da983d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SetTypeToExercises.vue"
export default component.exports